import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEvent } from '../../types';
import dayjs from 'dayjs';


const filterFutureEvents = (events: IEvent[]): IEvent[] => {
  const startOfDay = dayjs().hour(0).minute(0).second(0).millisecond(0);
  return events.filter(event => {
    const eventDate = dayjs(event.date);
    const isAfter = eventDate.isAfter(startOfDay);
    return isAfter;
  });
};


const getFilteredEventsFromStorage = (key: string): IEvent[] | undefined => {
  const storedEvents = localStorage.getItem(key);
  if (!storedEvents) return undefined;
  try {
    const events: IEvent[] = JSON.parse(storedEvents);
    return filterFutureEvents(events);
  } catch (error) {
    console.warn(`Failed to parse events from localStorage key: ${key}`, error);
    return undefined;
  }
};

interface UpcomingEventState {
  upcomingEvents: IEvent[] | undefined;
  updatingUpcomingEvents: boolean;
  upcomingEventsToday: IEvent[] | undefined;
  updatingUpcomingEventsToday: boolean;
  upcomingEventsNext: IEvent[] | undefined;
  updatingUpcomingEventsNext: boolean;
  eventsFilter: "all" | "in" | "out" | "undecided" | "queue";
}

const initialState: UpcomingEventState = {
  upcomingEvents: getFilteredEventsFromStorage('ilmo_upcomingEvents'),
  updatingUpcomingEvents: false,
  upcomingEventsToday: getFilteredEventsFromStorage('ilmo_upcomingEventsToday'),
  updatingUpcomingEventsToday: false,
  upcomingEventsNext: getFilteredEventsFromStorage('ilmo_upcomingEventsNext'),
  updatingUpcomingEventsNext: false,
  eventsFilter: "all",
};

export const upcomingEventSlice = createSlice({
  name: 'upcomingEvent',
  initialState,
  reducers: {
    updateUpcomingEvents: (state, action: PayloadAction<IEvent[]>) => {
      localStorage.setItem('ilmo_upcomingEvents', JSON.stringify(action.payload));
      state.upcomingEvents = action.payload;
    },
    setUpdatingUpcomingEvents: (state, action: PayloadAction<boolean>) => {
      state.updatingUpcomingEvents = action.payload;
    },
    updateUpcomingEventsToday: (state, action: PayloadAction<IEvent[]>) => {
      localStorage.setItem('ilmo_upcomingEventsToday', JSON.stringify(action.payload));
      state.upcomingEventsToday = action.payload;
    },
    updateUpcomingEventsNext: (state, action: PayloadAction<IEvent[]>) => {
      localStorage.setItem('ilmo_upcomingEventsNext', JSON.stringify(action.payload));
      state.upcomingEventsNext = action.payload;
    },
    setUpdatingUpcomingEventsToday: (state, action: PayloadAction<boolean>) => {
      state.updatingUpcomingEventsToday = action.payload;
    },
    setUpdatingUpcomingEventsNext: (state, action: PayloadAction<boolean>) => {
      state.updatingUpcomingEventsNext = action.payload;
    },
    setEventsFilter: (state, action: PayloadAction<"all" | "in" | "out" | "undecided" | "queue">) => {
      state.eventsFilter = action.payload;
    }
  },
});
export const { updateUpcomingEvents, setUpdatingUpcomingEvents, updateUpcomingEventsToday, setUpdatingUpcomingEventsToday, updateUpcomingEventsNext, setUpdatingUpcomingEventsNext, setEventsFilter } = upcomingEventSlice.actions;
export default upcomingEventSlice.reducer;